import React, { useEffect, useCallback, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import styles from "./index.module.scss";
import PoiSearch from "./PoiSearch";
import AutoComplete from "./AutoComplete";
import AmapMarker from "./AmapMarker";
import MessageBox from "../../../components/message-box";
import AMap from "../../../components/AMapComp";
import useRescueAddressHook from "../common/hooks/useRescueAddressHook";
import useAMapHook from "../../../hooks/useAMapHook";
import _ from "lodash";

export default function RescueAddress() {
  const history = useHistory();
  const [inputKeyword, setInputkeyword] = useState("");
  const [clickKeyword, setClickKeyword] = useState("");
  const [clickAdcode, setClickAdcode] = useState(0);
  const [suggestList, setSuggestList] = useState<any>([]);
  const [addressList, setAddressList] = useState<any>([]);
  const [selectAddress, setSelectAddress] = useState<any>({});
  const inputRef = useRef("");

  const { setRescueAddress } = useRescueAddressHook();

  const mapWrapper = useRef(null);
  const { mapEntity, loaded, userCurrentPosition } = useAMapHook({
    container: mapWrapper.current,
  });

  useEffect(() => {
    document.title = "救援位置";
  }, []);

  const handleInput = useCallback((event) => {
    const newInput = event.target.value;
    inputRef.current = newInput;
    setInputkeyword(newInput);

    if (newInput.length === 0) {
      setSuggestList([]);
      setAddressList([]);
      setSelectAddress({});
      setClickKeyword("");
    }
  }, []);

  const handleSearched = (list) => {
    setAddressList(list);
    setSelectAddress({});
  };

  const handleSetSuggestion = useCallback((list, keyword) => {
    // 增加时序判断
    if (inputRef.current === keyword) {
      setSuggestList(list);
    }
  }, []);

  const handleSelectSuggest = useCallback((item) => {
    setSuggestList([]);
    setClickKeyword(item.name);
    setClickAdcode(item.adcode || 0);
  }, []);

  const handleSelectAddress = useCallback((address) => {
    setSelectAddress(address);
  }, []);

  const handleSure = useCallback(async () => {
    if (!selectAddress.name || !selectAddress?.location) {
      MessageBox.toast("请搜索并选择取车地点");
      return;
    }

    //将地址信息保存到仓库中
    setRescueAddress((pre) => ({
      ...pre,
      acdtAddress: `${selectAddress.pname}${selectAddress.cityname}${selectAddress.adname}${selectAddress.name}`,
      acdtProvince: selectAddress?.pname,
      provinceAdcode: selectAddress?.pcode,
      acdtCity: selectAddress?.cityname,
      cityAdcode: selectAddress?.citycode,
      acdtDistrict: selectAddress?.adname,
      districtAdcode: selectAddress?.adcode,
      longitude: selectAddress?.location?.lng,
      latitude: selectAddress?.location?.lat,
    }));
    history.goBack();
  }, [selectAddress, history]);

  return (
    <div className={styles.pageRescueAddress}>
      <div className={styles.mapContainer}>
        <AMap loaded={loaded} mapEntity={mapEntity} mapWrapper={mapWrapper}>
          {/* 输入地址信息时自动显示可选地址 */}
          <AutoComplete
            keyword={inputKeyword}
            onSearched={handleSetSuggestion}
            userCurrentPosition={userCurrentPosition}
          ></AutoComplete>
          {/* 点击可选地址以后的小地址选项 */}
          <PoiSearch
            keyword={clickKeyword}
            adcode={clickAdcode}
            onSearched={handleSearched}
          ></PoiSearch>
          {/* 地图上地点的自动标记（通过经纬度） */}
          <AmapMarker
            rescuePosition={{
              lng: selectAddress?.location?.lng,
              lat: selectAddress?.location?.lat,
            }}
          ></AmapMarker>
        </AMap>
      </div>
      <div className={styles.addressContainer}>
        <div className={styles.searchBar}>
          <input
            className={styles.keywordInput}
            placeholder="搜索地点"
            type="text"
            value={inputKeyword}
            onChange={handleInput}
          />
          <button className={styles.sureBtn} onClick={handleSure}>
            确定
          </button>
        </div>
        {suggestList.length > 0 && (
          <div className={styles.suggestContainer}>
            {suggestList.map((item, index) => {
              return item.district ? (
                <div
                  className={styles.suggestItem}
                  key={index}
                  onClick={() => handleSelectSuggest(item)}
                >
                  <div className={styles.icon}></div>
                  <div className={styles.info}>
                    <span className={styles.name}>{item.name}</span>{" "}
                    <span className={styles.district}>{item.district}</span>
                  </div>
                </div>
              ) : null;
            })}
          </div>
        )}
        <div className={styles.results}>
          {addressList && addressList.length > 0 ? (
            addressList.map((item) => {
              return (
                <div
                  className={styles.addressItem}
                  key={item.id}
                  onClick={() => handleSelectAddress(item)}
                >
                  <div className={styles.addressInfo}>
                    <h3 className={styles.addressTitle}>{item.name}</h3>
                    <p className={styles.addressdetail}>
                      {item.cityname} {item.adname} {item.address}
                    </p>
                  </div>
                  <div
                    className={[
                      styles.radio,
                      selectAddress.id === item.id ? styles.selected : "",
                    ].join(" ")}
                  ></div>
                </div>
              );
            })
          ) : (
            <div className={styles.searchTip}>
              <div className={styles.icon}></div>
              <div className={styles.tipTxt}>
                请输入具体地点信息，如：广州亚运城
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
